<template>
  <section class="py-9 tablet:py-20">
    <div class="container-wrap">
      <div class="mb-4 tablet:mb-0">
        <div class="tablet:flex tablet:items-center">
          <div class="tablet:w-8/12 tablet:pr-2 desktop:pr-3">
            <h2 class="text-h2 mb-10 last:mb-0 tablet:line-clamp-2">
              {{ title }}
            </h2>
            <TheRichText
              v-if="descriptionHtml || description"
              class="mb-10 w-full text-sm leading-6 text-gray-700 tablet:line-clamp-7 tablet:text-base"
              :text="descriptionHtml || description"
              :is-html="!!descriptionHtml"
            />
          </div>
          <div v-if="!isMobile" class="tablet:w-4/12 tablet:pl-2 desktop:pl-3">
            <div class="flex flex-wrap">
              <TheButton
                v-if="button01?.text"
                :id="button01?.trackingCode"
                :to="provideFormatUrl(button01.link)"
                :title="button01.text"
                class="mb-3 w-full last:mb-0"
              >
                <span class="font-bold">
                  {{ button01.text }}
                </span>
              </TheButton>
              <TheButton
                v-if="button02?.text"
                :id="button02?.trackingCode"
                :to="provideFormatUrl(button02.link)"
                :title="button02.text"
                type="outline"
                class="mb-3 w-full last:mb-0"
              >
                <span class="font-bold">
                  {{ button02.text }}
                </span>
              </TheButton>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMobile" class="flex flex-wrap">
        <TheButton
          v-if="button01?.text"
          :id="button01?.trackingCode"
          :to="button01.link"
          :title="button01.text"
          class="mb-4 w-full last:mb-0"
        >
          <span class="font-bold">
            {{ button01.text }}
          </span>
        </TheButton>
        <TheButton
          v-if="button02?.text"
          :id="button02?.trackingCode"
          :to="button02.link"
          :title="button02.text"
          type="outline"
          class="mb-4 w-full last:mb-0"
        >
          <span class="font-bold">
            {{ button02.text }}
          </span>
        </TheButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  /**
   * @see https://www.figma.com/design/QJ3ZvEbUHI9xI11iudYf8U/Advantech-WISE-Library?node-id=13363-39852&t=89PIFDiQEC4zcSbf-0
   */

  interface IButton {
    text: string;
    link: string;
    trackingCode?: string;
  }

  interface IProps {
    title: string;
    description: string;
    descriptionHtml?: string;
    button01?: IButton;
    button02?: IButton;
    theme?: TTheme;
  }

  withDefaults(defineProps<IProps>(), {
    descriptionHtml: undefined,
    button01: undefined,
    button02: undefined,
    theme: 'blue',
  });

  const { isMobile } = useScreen();
  const { provideFormatUrl } = useFormatUrl();
</script>
